// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__2qwhZ","header":"ReportDetails_header__ExaCJ","title":"ReportDetails_title__2ijhY","left":"ReportDetails_left__34T_h"};